/**
 * Custom archive functions
 */

window.onload = ( $ => {

    const productTypesDropdown = $( '.product-types__dropdown' ),
        productTypesButton = $( '.product-types__button' ),
        ajax_url = productTypesDropdown.data('ajax_url'),


        /**
         * Prevent any default actions
         *
         * @param e
         * @returns {boolean}
         * @private
         */
        __no_return = function( e ) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        },

        /**
         * Add class to block UI
         * @private
         */
        __block_ui = function() {
            $( '.products, .product-types' ).addClass( 'blocked' );
        },


        /**
         * Add class to unblock UI
         * @private
         */
        __unblock_ui = function() {
            $( '.products, .product-types' ).removeClass( 'blocked' );
        },


        /**
         * Close product-types dropdown
         *
         * @private
         */
        __close_dropdown = function() {
            productTypesButton.removeClass('open');
            productTypesDropdown.hide();
        },



        /**
         * Open product-types dropdown
         *
         * @private
         */
        __open_dropdown = function() {
            productTypesButton.addClass('open');
            productTypesDropdown.show();
        },



        /**
         * Toggle product-types dropdown
         *
         * @private
         */
        __toggle_dropdown = function( e ) {
            productTypesButton.hasClass('open') ? __close_dropdown() : __open_dropdown();
        },



        /**
         * Rendering products
         *
         * @param response object
         * @param isPopState boolean
         * @private
         */
        __render_products = function( response, isPopState ) {
            const titleElem = $( '.page-title' ),
                descriptionElem = $( '.term-description' ),
                pageDescriptionElem = $( '.page-description' ),
                contentElem = $( '.products' );

            descriptionElem.remove();
            pageDescriptionElem.remove();

            titleElem.text( response.title );

            if ( response.description !== '' ) {
                titleElem.after( `<div class="term-description">${ response.description }</div>` )
            }

            let html = $( response.html );
            html.find( '.product-card' ).addClass( 'hidden' );

            contentElem.html( html );

            if ( ! isPopState ) {
                const new_history_state = [];

                if ( Array.isArray( response.category_slug ) ) {
                    response.category_slug.forEach( function( slug ) {
                        new_history_state.push({
                            category_id: response.category_id,
                            category_slug: slug,
                            category_link: response.category_link
                        })
                    })
                }

                window.history.pushState( new_history_state, '', response.category_link);
            }

            if ( isPopState ) {
                if ( Array.isArray( response.category_slug ) ) {
                    $( '.product-types__checkbox' ).prop('checked', false);
                    response.category_slug.forEach( function( slug ) {
                        $( `#product-category-${slug}` ).prop( 'checked', true );
                    })
                }
            }

            $('.product-card').each( function( index, element) {
                setTimeout( function() {
                    $( element ).removeClass( 'hidden' );
                }, index * 100)
            });
        },


        /**
         * Send AJAX request to get filtered products
         *
         * @private
         */
        __send_request = function( data, isPopState = false ) {
            $.ajax( {
                url: ajax_url,
                data: {
                    'action': 'buddy_get_products_list',
                    'categories_query': data,
                },
                processData: true,
                type: 'post',
                beforeSend: ( jqXHR, settings ) => {
                    __block_ui();
                },
                success: response => {
                    __render_products( response, isPopState );
                },
                error: ( a, b, error ) => {
                    if ( error ) {
                        console.log( error );
                        window.location = data.category_link;
                    }
                },
                complete: jqXHR => {
                    __unblock_ui();
                }
            } );
        },


        /**
         * Browser history handler
         *
         * @private
         */
        __browse_through_history = function( ) {
            if ( !history.state ) {
                location.reload();
                return;
            }
            __close_dropdown();
            __send_request( history.state, true );
        },


        /**
         * Change product type handler
         *
         * @private
         */
        __filter_products = function( e ) {
            __no_return( e );
            __close_dropdown();

            const data = [];

            $('.product-types__checkbox:checked').each( function( index, element) {
                const dataSet = JSON.parse(element.value);

                data.push( {
                    category_id: dataSet.category_id,
                    category_slug: dataSet.category_slug,
                    category_link: dataSet.category_link
                } );
            })

            __send_request( data );
        },




        /**
         * Assign all custom cart events
         *
         * @private
         */
        __assign = function() {
            $( '.product-types__checkbox' ).off().on( 'change', __filter_products );
            $( '.product-types__button' ).off().on( 'click', __toggle_dropdown );
            $( window ).on( "popstate", __browse_through_history );
        },



        /**
         * Initialize
         *
         * @private
         */
        __init = function() {
            __assign();
            console.log( 'Archive page JS initiated!' );
        };


    return {
        /**
         * Call to init ourselves only when we are on our archive page
         */
        init: function() {
            if ( !$( '.archive' ).length ) return false;
            __init();
            return true;
        }
    }

} )( jQuery.noConflict() ).init();
